export default "__VITE_ASSET__Cq0_kbqW__"